import type { Category } from '@/pages/category/page';

export const categories: Category[] = [
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    description: '最新明星绯闻、恋情曝光、圈内动态一网打尽',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20entertainment%20backdrop%20with%20soft%20golden%20and%20coral%20gradient%20lights%2C%20blurred%20paparazzi%20flashes%20effect%2C%20luxurious%20and%20dramatic%20atmosphere%2C%20editorial%20style%2C%20rich%20warm%20tones%2C%20cinematic%20lighting%2C%20elegant%20abstract%20composition%20with%20bokeh&width=800&height=500&seq=cat-mingxing&orientation=landscape',
  },
  {
    slug: 'wanghong-baoliao',
    name: '网红爆料',
    description: '头部网红翻车现场、塌房实录、私下真面目',
    icon: 'ri-user-smile-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20influencer%20theme%20backdrop%2C%20warm%20amber%20and%20rose%20gradient%2C%20soft%20bokeh%20lights%2C%20modern%20digital%20aesthetic%2C%20glamorous%20but%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20rich%20textures%2C%20cinematic%20composition&width=800&height=500&seq=cat-wanghong&orientation=landscape',
  },
  {
    slug: 'zongyi-neimu',
    name: '综艺内幕',
    description: '热门综艺节目背后的暗箱操作与不为人知的秘密',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20production%20backdrop%20with%20warm%20lighting%2C%20soft%20coral%20and%20gold%20color%20palette%2C%20theatrical%20curtains%20blurred%20in%20background%2C%20dramatic%20stage%20lighting%20effects%2C%20entertainment%20industry%20aesthetic%2C%20editorial%20photography%2C%20cinematic%20mood&width=800&height=500&seq=cat-zongyi&orientation=landscape',
  },
  {
    slug: 'yingshi-heiliao',
    name: '影视黑料',
    description: '电影电视剧选角内幕、片场冲突、资本操控揭秘',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20industry%20backdrop%20with%20warm%20golden%20hour%20lighting%2C%20cinematic%20lens%20flare%2C%20soft%20amber%20and%20terracotta%20gradient%2C%20movie%20set%20vibe%20blurred%2C%20dramatic%20and%20mysterious%20atmosphere%2C%20editorial%20style%20photography%2C%20rich%20warm%20tones&width=800&height=500&seq=cat-yingshi&orientation=landscape',
  },
  {
    slug: 'yinle-quan',
    name: '音乐圈',
    description: '歌手抄袭争议、演唱会假唱、音乐节内幕曝光',
    icon: 'ri-music-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20concert%20backdrop%20with%20warm%20stage%20lights%2C%20soft%20coral%20and%20gold%20gradient%2C%20blurred%20crowd%20silhouettes%2C%20dramatic%20spotlight%20effects%2C%20entertainment%20industry%20vibe%2C%20editorial%20photography%2C%20rich%20atmospheric%20textures&width=800&height=500&seq=cat-yinle&orientation=landscape',
  },
];